const STORAGE_KEY = 'gundo-vida-attribution';
const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] as const;

export interface AttributionData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  entry_referrer?: string;
  entry_path?: string;
  entry_timestamp?: string;
}

export function captureAttribution(): AttributionData | null {
  if (typeof window === 'undefined') return null;

  const existing = readAttribution();
  if (existing) return existing;

  const params = new URLSearchParams(window.location.search);
  const utms: AttributionData = {};
  let hasUtm = false;
  for (const key of UTM_KEYS) {
    const value = params.get(key);
    if (value) {
      utms[key] = value;
      hasUtm = true;
    }
  }

  const referrer = document.referrer || '';
  const referrerHost = referrer ? safeHost(referrer) : '';
  const isExternalReferral = referrerHost && referrerHost !== window.location.host;

  if (!hasUtm && !isExternalReferral) return null;

  const data: AttributionData = {
    ...utms,
    entry_referrer: referrer || undefined,
    entry_path: window.location.pathname,
    entry_timestamp: new Date().toISOString(),
  };

  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* storage unavailable — fall through */
  }
  return data;
}

export function readAttribution(): AttributionData | null {
  if (typeof window === 'undefined') return null;
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function getAttributionParams(): Record<string, string> {
  const data = readAttribution();
  if (!data) return {};
  const out: Record<string, string> = {};
  for (const [k, v] of Object.entries(data)) {
    if (typeof v === 'string' && v) out[k] = v;
  }
  return out;
}

function safeHost(url: string): string {
  try {
    return new URL(url).host;
  } catch {
    return '';
  }
}
